var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { ChevronLeft, ChevronRight } from '../../../foundations/icons';
import { TextLink } from '../../TextLink';
import styles from './BreadcrumbLink.module.scss';
export function BreadcrumbLink(_a) {
    var _b;
    var _c = _a.back, back = _c === void 0 ? false : _c, className = _a.className, props = __rest(_a, ["back", "className"]);
    return (React.createElement("div", { className: cx(styles.wrapper, (_b = {}, _b[styles.back] = back, _b)) },
        back && React.createElement(ChevronLeft, { size: "xsmall" }),
        React.createElement(TextLink, __assign({ size: "medium", underline: "always" }, props, { className: cx(styles.link, className) })),
        back ? React.createElement("div", { className: styles.separator }, "|") : React.createElement(ChevronRight, { size: "xsmall" })));
}
//# sourceMappingURL=BreadcrumbLink.js.map